import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  body {
    font-style: normal;
    color: #f3f3f3;
    background-color: #131513;
  }
`

export default GlobalStyle
